// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"5437e759","222":"076cc407","302":"0b22e51d","304":"1d79d414","333":"15981c05","363":"79deb4c2","369":"e38d26a1","389":"6b01e520","671":"f990661b","872":"68b7ccf0","895":"8703bb3c"}[chunkId] + ".chunk.js";
};